import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';

//Components
import ProductsPage from './ProductsPage';

//Actions
import { getPageInfo } from './../../reducers/generalReducer';

//Components
import Breadcrumbs from './../../components/Global/Breadcrumbs/Breadcrumbs';
import CountdownTimer from './../../../src/components/Global/Header/CountdownTimer';

const ProductsPageContainer = ({ info }) => {
  return (
    <Col xs={12} className="homeContainer">
      <CountdownTimer/>
      <Row>
        <Container className="bg-primary">
          <Breadcrumbs />
          <section className="mb-4 px-4 pb-4 border-container">
            <h3 className="first-title text-center my-4 interna-resultados">Nuestros Productos</h3>
            { info && <ProductsPage info={info} />}
          </section>
        </Container>
      </Row>
    </Col>
  );
};

const mapStateToProps = (state) => {
  const { loading, error } = state.general.pages;
  return {
    loading,
    error,
    info: getPageInfo(state, 'nuestros-productos')
  };
};

export default connect(mapStateToProps)(ProductsPageContainer);
